module.exports = __webpack_public_path__ + "static/media/save.svg.73472294.png";